import { LogAppEventPayload, LogAppEventResult } from "constellation-sdk/dist/client/modules/self/dtos/log-app-event.dto";
import { api } from "../../../../common/api/api";

class AppEventProviderService {
    public async logAppEvent(payload: LogAppEventPayload): Promise<LogAppEventResult> {
        return api.self.logAppEvent(payload);
    }
}

export const service = new AppEventProviderService();